import { toast } from "react-toastify";

export const esDNIValido = (dni) =>{
    if (!dni) {
        toast.info('Debe introducir un N° de DNI');
        return false;
    } else if(isNaN(dni)){
        toast.info('Debe introducir un valor numérico para el DNI');
        return false;
    }
    return true;
}
